import React from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  HStack,
  Stack,
  Text,
} from '@chakra-ui/react';
import { Button } from '~/components/Button';
import { PrivacyPolicyView } from '~/types/privacyPolicy';
import logo from '~/assets/logo-service-gray.png';
import { TextEditor } from '~/components/TextEditor/TextEditor';

interface PrivacyPolicyDialogProps {
  setarStatusLido?: (id: number) => void;
  onCloseModal: () => void;
  isOpenModal: boolean;
  politica: PrivacyPolicyView;
}

export const PrivacyPolicyDialog: React.FC<PrivacyPolicyDialogProps> = ({
  politica,
  setarStatusLido,
  onCloseModal,
  isOpenModal,
}) => {
  return (
    <AlertDialog
      closeOnEsc={false}
      closeOnOverlayClick={false}
      motionPreset="slideInBottom"
      leastDestructiveRef={undefined}
      onClose={onCloseModal}
      isOpen={isOpenModal}
      isCentered
      size="4xl"
    >
      <AlertDialogOverlay />
      <AlertDialogContent as="form">
        <AlertDialogHeader fontSize="xl" paddingBottom="10px" marginBottom={0}>
          <Text paddingBottom="10px">Termos de uso</Text>
        </AlertDialogHeader>
        <AlertDialogBody paddingTop={0}>
          <Stack gridGap={3}>
            <HStack justifyContent="space-between">
              <Text fontSize="15px">
                <b>Data de publicação:</b> {politica?.formattedPublicacao}
              </Text>
              <img src={logo} alt="Logo" width="100px" />
            </HStack>
            <Text fontSize="15px" fontWeight="bold">
              {politica?.descricao}
            </Text>
            <TextEditor value={politica?.mensagem} visualizacao />
          </Stack>
        </AlertDialogBody>
        <AlertDialogFooter>
          {setarStatusLido ? (
            <Button ml={3} onClick={() => setarStatusLido(politica.id!)}>
              Fechar
            </Button>
          ) : (
            <Button variant="secondary" ml={3} onClick={onCloseModal}>
              Fechar
            </Button>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
